import { Box, Text } from '@mantine/core';
import { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function LandingPage() {
	const containerRef = useRef<HTMLDivElement>(null);
	const navigate = useNavigate();

	useEffect(() => {
		navigate('/auth/login');
	}, [navigate]);

	return (
		<Box
			ref={containerRef}
			style={{
				height: '100vh',
				overflow: 'hidden',
			}}
		>
			<Text>Landing page</Text>
		</Box>
	);
}
